import React from 'react';
import {
  Create,
  Edit,
  EditButton,
  Filter,
  maxLength,
  minLength,
  required,
  SearchInput,
  TextField,
  TextInput,
} from 'react-admin';
import { ZippityDatagrid, ZippitySimpleForm } from '../../components';
import EmojiInput from '../../EmojiInput';
import ListWithCSVImport from '../../components/ListWithCSVImport';

const ScheduleTypeFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
  </Filter>
);

export const ScheduleTypeList = (props) => (
  <div>
    <ListWithCSVImport
      {...props}
      bulkActionButtons={false}
      filters={<ScheduleTypeFilter />}
      sort={{ field: 'name', order: 'ASC' }}
      perPage={50}
    >
      <ZippityDatagrid>
        <TextField source="created_at" />
        <TextField source="modified_at" />
        <TextField source="name" />
        <TextField source="emoji" style={{ fontSize: '1.5em' }} />
        <EditButton />
      </ZippityDatagrid>
    </ListWithCSVImport>
  </div>
);

const validateName = [required(), minLength(2), maxLength(100)];
const validateEmoji = [required(), minLength(1), maxLength(10)];

export const ScheduleTypeEdit = (props) => (
  <Edit undoable={false} {...props}>
    <ZippitySimpleForm>
      <TextInput validate={validateName} source="name" />
      <EmojiInput validate={validateEmoji} source="emoji" />
    </ZippitySimpleForm>
  </Edit>
);

export const ScheduleTypeCreate = (props) => (
  <Create {...props}>
    <ZippitySimpleForm>
      <TextInput validate={validateName} source="name" />
      <EmojiInput validate={validateEmoji} source="emoji" />
    </ZippitySimpleForm>
  </Create>
);
